import type { DeleteCommentMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { DeleteCommentDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

/**
 * Flag-gated wrapper (RSP-6496). Both paths return `{ Id }`.
 */
export const useDeleteComment = createMutationHook({
  name: 'deleteComment',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.comment.delete.mutationOptions({ onSuccess }),
  mapInput: (input: { Id: string }) => input,
  invalidate: (trpc) => [
    trpc.frontend.comment.commentsByConversationId.queryKey(),
  ],
  mapResponse: (result: { Id: string }): { Id: string } => ({
    Id: result.Id,
  }),
  graphqlDocument: DeleteCommentDocument,
  graphqlVariables: (input: { Id: string }) => ({ Id: input.Id }),
  mapGraphqlResponse: (data: DeleteCommentMutation): { Id: string } => {
    if (!data.delete_comment_by_pk) {
      throw new Error('Failed to delete comment');
    }

    return { Id: data.delete_comment_by_pk.Id };
  },
});
